import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CountriesModel } from 'src/models/countries.model';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  private countriesSubject: BehaviorSubject<Array<CountriesModel>>;
  public countries$: Observable<Array<CountriesModel>>;
  private cachedCountries: CountriesModel[] | null = null;

  constructor(private http: HttpClient) {
    this.countriesSubject = new BehaviorSubject<Array<CountriesModel>>([]);
    this.countries$ = this.countriesSubject.asObservable();
  }

  public get value(): Array<CountriesModel> {
    return this.countriesSubject.value;
  }

  update(countries: Array<CountriesModel>){
    this.cachedCountries = countries;
    this.countriesSubject.next(countries);
  }

  list(): Observable<Array<CountriesModel>> {
    if (this.cachedCountries) {
      console.log('Returning cached countries');
      return of(this.cachedCountries);
    }
    return this.http.get(`${environment.apiUrl}countries/`).pipe(
      tap((data: Array<CountriesModel>) => {
        // Mise à jour du cache
        this.cachedCountries = data;
        console.log('Countries data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<CountriesModel>>;
  }

  all(): Observable<Array<CountriesModel>> {
    return this.http.get(`${environment.apiUrl}countries/all/`) as Observable<Array<CountriesModel>>;
  }
}
